import { render, staticRenderFns } from "./RegionPicker.vue?vue&type=template&id=0b5da52e&scoped=true&"
import script from "./RegionPicker.vue?vue&type=script&lang=js&"
export * from "./RegionPicker.vue?vue&type=script&lang=js&"
import style0 from "./RegionPicker.vue?vue&type=style&index=0&id=0b5da52e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5da52e",
  null
  
)

export default component.exports